import "../Css/Footer.css";


export default function Footer(){
    return (
      <footer className="footer">
        <a href="https://github.com/jadeeg/React-weather-app">
        {""} Open source project 
        </a>{" "}
        by <a href="© "> Jade Gonçalves. </a> © 2025
      </footer>
    );
}